/**
 * ml-facets-universal.js
 *
 * When a customer filters by Model, automatically include products tagged
 * with "All Models" (universal-fit items like graphics) in the results.
 *
 * Shopify's filters use OR within a group, so appending "All Models" to
 * whichever model values are already selected pulls in universal products
 * without hiding anything specific.
 *
 * Requires: products with no specific model must have their Model metafield
 * set to exactly "All Models" (the UNIVERSAL_VALUE constant below).
 */

(function () {
  const UNIVERSAL_VALUE = 'All Models';

  /**
   * Find the URL param name for the Model filter by scanning rendered
   * checkbox inputs inside the filter group whose label is "Model".
   */
  function getModelParamName() {
    const labelEls = document.querySelectorAll('.facets__summary-label');
    for (const el of labelEls) {
      // firstChild is the text node; textContent catches both cases
      const text = (el.firstChild?.nodeValue || el.textContent || '').trim().toLowerCase();
      if (text === 'model') {
        const details = el.closest('details');
        const input = details?.querySelector('input[type="checkbox"]');
        if (input?.name) return input.name;
      }
    }
    return null;
  }

  function applyPatch() {
    if (typeof FacetFiltersForm === 'undefined') {
      setTimeout(applyPatch, 50);
      return;
    }

    const _orig = FacetFiltersForm.prototype.createSearchParams;

    FacetFiltersForm.prototype.createSearchParams = function (form) {
      const formData = new FormData(form);
      const params = new URLSearchParams(formData);

      const modelParam = getModelParamName();
      if (modelParam) {
        const modelValues = params.getAll(modelParam);
        // Only inject when a specific model is chosen and "All Models" isn't already there
        if (modelValues.length > 0 && !modelValues.includes(UNIVERSAL_VALUE)) {
          params.append(modelParam, UNIVERSAL_VALUE);
        }
      }

      return params.toString();
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPatch);
  } else {
    applyPatch();
  }
})();
